module.exports = {
  lasHost: '/api',
  sportHost: '/api',
  icsHost: '/ics',
  'commitId': 'aa7052c9be6056ce916be2990839151b92bc4624'
}
